export const SET_BIBLIOTECAS = "BIBLIOTECAS/SET_BIBLIOTECAS";
export const SET_BIBLIOTECA = "BIBLIOTECAS/SET_BIBLIOTECA";
export const SET_BIBLIOTECA_FILES = "BIBLIOTECAS/SET_BIBLIOTECA_FILES";
export const SET_PAGINATION = "BIBLIOTECAS/SET_PAGINATION";
export const SET_PAGINATION_FILES = "BIBLIOTECAS/SET_PAGINATION_FILES";
export const SET_LAYOUT = "BIBLIOTECAS/SET_LAYOUT";
